import React from "react";
import { Column } from "react-table";
import { Table } from "shared/core/Table";
import { useAuth } from "shared/context/auth";
import { useCopies } from "shared/hooks/useCopies";
import AssignmentCell, { getAssignmentCellValue } from "./components/assignmentCell";
import CellEllipsis from "shared/core/Table/components/cellEllipsis";
import { ApiRegistrationParticipantForManagement } from "shared/types/ApiRegistrationParticipantForManagement";
import OrgAdminStatusCell, { getOrgAdminStatusCellValue } from "./components/orgAdminStatusCell";

export default function ManageOrgAdminTable(props: {
  list: Array<ApiRegistrationParticipantForManagement>;
  tableRef: React.Ref<any>;
}) {
  const copies = useCopies();
  const { userDetail } = useAuth();

  const getDisplayName = React.useCallback(
    ({ id, firstName, lastName }: ApiRegistrationParticipantForManagement) =>
      userDetail?.id === id
        ? copies.get("participant.name.me", {
            0: `${firstName} ${lastName}`
          })
        : `${firstName} ${lastName}`,
    [copies, userDetail?.id]
  );

  const tableColumns: Array<Column<ApiRegistrationParticipantForManagement>> = React.useMemo(() => {
    return [
      {
        id: "name",
        Header: copies.get("name"),
        accessor: getDisplayName,
        width: 100,
        Cell: CellEllipsis
      },
      {
        id: "workEmail",
        Header: copies.get("work.email"),
        accessor: "workEmail",
        width: 130,
        Cell: CellEllipsis
      },
      {
        id: "status",
        Header: copies.get("org.admin"),
        accessor: ({ nonAttendeeApplication, participantRoles }) =>
          getOrgAdminStatusCellValue(nonAttendeeApplication?.status, participantRoles, copies).value,
        width: 64,
        Cell: OrgAdminStatusCell
      },
      {
        id: "action",
        Header: copies.get("action"),
        accessor: participantData => getAssignmentCellValue(copies, participantData, userDetail).value,
        width: 40,
        Cell: AssignmentCell
      }
    ];
  }, [copies, getDisplayName, userDetail]);

  return (
    <Table<ApiRegistrationParticipantForManagement>
      tableRef={props.tableRef}
      data={props.list}
      columns={tableColumns}
      disableFilters
    />
  );
}
